import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { filter, Observable, take } from 'rxjs';
import { URLPaths } from 'app/core/mips/common/utilities/urlPaths.config';
import { RbacState, RbacTokenResponse } from 'app/core/store/rbac/rbac.state';
import { rbacFailed, rbacLoaded, rbacLoading } from 'app/core/store/rbac/rbac.action';
import { selectRbacState } from 'app/core/store/rbac/rbac.selectors';

@Injectable({ providedIn: 'root' })
export class RbacService {
  constructor(private http: HttpClient, private store: Store) {}

/**
 * Loads RBAC data from the backend and stores it in NgRx.
 * Reuses the existing RBAC state if it is already loading or loaded.
 * Retries the request if the previous attempt failed.
 */
ensureLoaded(): Observable<RbacState> {
    let current: RbacState | undefined;
    this.store.select(selectRbacState).pipe(take(1)).subscribe((s) => (current = s));

    if (current?.status === 'idle' || current?.status === 'error') {
      this.store.dispatch(rbacLoading());
      this.http.get<RbacTokenResponse>(URLPaths.URL_RBAC_TOKEN).subscribe({
        next: (response) => this.store.dispatch(rbacLoaded({ response })),
        error: () => this.store.dispatch(rbacFailed()),
      });
    }
    // Wait until the RBAC request completes before allowing the caller to continue.
    return this.store.select(selectRbacState).pipe(
      filter((s) => s.status === 'loaded' || s.status === 'error'),
      take(1)
    );
  }
}